import {
    BooleanInput,
    minLength,
    ReferenceInput,
    required,
    SelectInput,
    TextInput,
    useRecordContext,
} from 'react-admin';
import { Grid } from '@mui/material';
import { SimpleForm } from '@components/SimpleForm';

const Password = () => {
    const record = useRecordContext();
    return !record ? (
        <TextInput type="password" source="password" validate={[required()]} />
    ) : null;
};

export const UserForm = () => {
    return (
        <SimpleForm>
            <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <ReferenceInput source="roleId" reference="roles">
                        <SelectInput
                            optionText="name"
                            validate={[required()]}
                        />
                    </ReferenceInput>
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextInput
                        source="userid"
                        validate={[required(), minLength(2)]}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <Password />
                </Grid>
                <Grid item xs={12}>
                    <TextInput source="name" validate={[required()]} />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextInput source="phone" validate={[required()]} />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextInput source="email" />
                </Grid>
                <Grid item xs={12}>
                    <TextInput source="address" multiline />
                </Grid>
                <Grid item xs={12}>
                    <BooleanInput source="isActive" defaultValue={true} />
                </Grid>
            </Grid>
        </SimpleForm>
    );
};
